import React, { useState, useEffect } from 'react';
import { Space, Typography, message } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { getOwnerDashboardStats, OwnerDashboardStats } from '../../services/statsApi';
import QuickStartActions from './owner/QuickStartActions';
import NeedsAttentionPanel from './owner/NeedsAttentionPanel';
import EstimatesActionPanel from './owner/EstimatesActionPanel';
import PartsStatusPanel from './owner/PartsStatusPanel';
import KpiStrip from './owner/KpiStrip';
import ShopStatusRow from './owner/ShopStatusRow';
import PipelineBar from './owner/PipelineBar';

const { Title, Text } = Typography;

const ZERO_PIPELINE = {
  new: 0, scheduled: 0, in_progress: 0, waiting_parts: 0, waiting_approval: 0, completed: 0,
};

const OwnerDashboard: React.FC = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState<OwnerDashboardStats | null>(null);

  useEffect(() => {
    let active = true;
    getOwnerDashboardStats()
      .then((data) => { if (active) setStats(data); })
      .catch((err) => {
        console.error('Failed to load dashboard stats:', err);
        message.error('Failed to load dashboard statistics');
      });
    return () => { active = false; };
  }, []);

  return (
    <div style={{ padding: '16px 12px', maxWidth: '100%', boxSizing: 'border-box' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <Title level={2} style={{ marginBottom: 0 }}>Owner Dashboard</Title>
          <Text type="secondary">Welcome back, {user?.first_name} — here's what needs you today.</Text>
        </div>

        <QuickStartActions />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 16 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 16 }}>
            <NeedsAttentionPanel />
            <EstimatesActionPanel />
            <PartsStatusPanel />
          </div>

          <KpiStrip stats={stats} />

          <ShopStatusRow
            activeTechnicians={stats?.activeTechnicians ?? 0}
            totalTechnicians={stats?.totalTechnicians ?? 0}
            pendingApprovals={stats?.pendingApprovals ?? 0}
            overdueWorkOrders={stats?.overdueWorkOrders ?? 0}
          />

          <PipelineBar counts={stats?.woCountsByStatus ?? ZERO_PIPELINE} />
        </div>
      </Space>
    </div>
  );
};

export default OwnerDashboard;
